export const VALUE_LIST_TYPE = {
	CATEGORY: "category",
	MULTIPLE_CHOICE: "multiple-choice",
	RATE: "rate",
	DILEMMA: "dilemma",
};
